import type { ReactNode } from "react";

import type { IconProp } from "@fortawesome/fontawesome-svg-core";

export enum CommandbarFilterTabType {
  ALL = "All",
  COMMAND = "Command",
  PAGE = "Page",
  ACCOUNT = "Account",
  OPPORTUNITY = "Opportunity",
  CONTACT = "Contact",
}

export type CommandbarFilterTab = {
  label: CommandbarFilterTabType;
  icon?: IconProp;
};

export enum CommandbarShortcutKeys {
  META = "meta",
  LEFT_SQUARE_BRACKET = "[",
  RIGHT_SQUARE_BRACKET = "]",
  ENTER = "Enter",
  ARROW_UP = "ArrowUp",
  ARROW_DOWN = "ArrowDown",
}

export enum CommandbarItemType {
  COMMAND = "Command",
  ACCOUNT = "Account",
  OPPORTUNITY = "Opportunity",
  CONTACT = "Contact",
  PAGE = "Page",
}

export type ICommandbarItem = {
  id: string;
  label: string;
  description?: string;
  faIcon?: IconProp;
  customIcon?: ReactNode;
  imageUrl?: string;
  onClick?: () => void;
  href?: string;
  openInNewTab?: boolean;
  type: CommandbarItemType;
  objectType?:
    | CommandbarFilterTabType.ACCOUNT
    | CommandbarFilterTabType.OPPORTUNITY
    | CommandbarFilterTabType.CONTACT;
  ctaLabel: string;
};

/**
 * 1. Title is the name of the account, contact, opportunity, etc.
 * 2. Description is the email of the contact, domain of the account, etc.
 * 3. Image URL is the avatar of the contact, logo of the account, etc.
 * 4. Object type is the type of the object, e.g. account, contact, opportunity, etc.
 */
export type SearchObjectsResponse = {
  object_id: string;
  title: string;
  description: string;
  image_url: string;
  object_type: string;
};

export type SearchObjectsWithDataResponse<T = Record<string, any>> =
  SearchObjectsResponse & {
    object_data: T;
  };
